import React from 'react';

export const getHighlightedText = (text, highlight) => {
  if (!highlight) return <span>{text}</span>;

  const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const escapedHighlight = escapeRegExp(highlight);
  const parts = text.split(new RegExp(`(${escapedHighlight})`, 'gi'));

  return (
    <span>
      {parts.map((part, i) => (
        <span
          key={i}
          style={part.toLowerCase() === highlight.toLowerCase() ? { color: 'red' } : {}}
        >
          {part}
        </span>
      ))}
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/Content/utils.js